import { render, staticRenderFns } from "./MailboxTaginput.vue?vue&type=template&id=aa24586c"
import script from "./MailboxTaginput.vue?vue&type=script&lang=js"
export * from "./MailboxTaginput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports